import { useEffect, useState, type FormEvent } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/dramas", label: "短剧库" },
  { to: "/cast", label: "演员表查询" },
  { to: "/news", label: "爆料资讯" },
  { to: "/about", label: "关于我们" },
];

export default function SiteHeader() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const submitSearch = (event: FormEvent) => {
    event.preventDefault();
    const value = keyword.trim();
    if (!value) return;
    navigate(`/dramas?q=${encodeURIComponent(value)}`);
    setMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="w-full border-b border-background-200 bg-background-50/90 backdrop-blur-md">
        <div className="mx-auto flex h-[72px] w-full max-w-content items-center gap-3 px-4 md:px-6">
          <Link to="/" className="flex items-center gap-2.5 whitespace-nowrap">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-movie-2-line text-lg"></i>
            </span>
            <span className="flex flex-col leading-none">
              <strong className="font-heading text-lg font-bold tracking-tight text-foreground-950">
                短剧爆料社
              </strong>
              <span className="mt-0.5 text-[11px] tracking-[0.22em] text-foreground-500">
                DUANJU INSIDER
              </span>
            </span>
          </Link>

          <nav className="ml-6 hidden items-center gap-1 lg:flex" aria-label="主导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `rounded-md px-3.5 py-2 text-sm transition-colors ${
                    isActive
                      ? "bg-primary-50 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <form
            onSubmit={submitSearch}
            className="ml-auto hidden items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-1.5 md:flex"
            role="search"
          >
            <span className="flex h-5 w-5 items-center justify-center text-foreground-500">
              <i className="ri-search-line text-base"></i>
            </span>
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜剧名 / 演员"
              aria-label="搜索短剧"
              className="w-32 bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-400 xl:w-44"
            />
          </form>

          <button
            type="button"
            onClick={() => setMenuOpen((open) => !open)}
            aria-label="展开菜单"
            aria-expanded={menuOpen}
            className="ml-auto flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-800 md:ml-2 lg:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-b border-background-200 bg-background-50 px-4 pb-5 pt-3 lg:hidden">
          <form
            onSubmit={submitSearch}
            className="mb-3 flex items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2"
            role="search"
          >
            <span className="flex h-5 w-5 items-center justify-center text-foreground-500">
              <i className="ri-search-line text-base"></i>
            </span>
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜剧名 / 演员"
              aria-label="搜索短剧"
              className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400"
            />
          </form>
          <nav className="flex flex-col" aria-label="移动端导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-sm ${
                    isActive
                      ? "bg-primary-50 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}